import { useTranslation } from "react-i18next";
import ActionButton from "./ActionButton";

// ─── Component ─────────────────────────────────────────────────

/**
 * ChoiceScreen
 *
 * First screen of the no-code flow. Greets the visitor and offers two
 * paths: enter the personal code they received with their invitation,
 * or let the couple know they'd like to come even without one.
 *
 * Visual hierarchy is deliberately asymmetric — the primary button
 * covers the common case (most guests received a code), while the
 * alternative sits below as an underlined link so it's discoverable
 * without competing for attention.
 *
 * Props:
 *   onChooseCode    — switch to the code entry screen
 *   onChooseRequest — switch to the request-to-attend flow
 */
const ChoiceScreen = ({ onChooseCode, onChooseRequest }) => {
  const { t } = useTranslation();
  return (
    <div style={{ textAlign: "center", padding: "16px 0 8px" }}>
      <h2
        id="rsvp-modal-title"
        className="heading-60"
        style={{ margin: 0, marginBottom: 10 }}
      >
        {t("rsvp.choice.title")}
      </h2>
      <p
        className="body-16"
        style={{
          opacity: 0.65,
          margin: 0,
          marginBottom: 32,
          maxWidth: 440,
          marginLeft: "auto",
          marginRight: "auto",
        }}
      >
        {t("rsvp.choice.subtitle")}
      </p>

      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: 16,
        }}
      >
        <ActionButton variant="primary" onClick={onChooseCode}>
          {t("rsvp.choice.codeButton")}
        </ActionButton>
      </div>

      {/* "or" divider + demoted secondary path */}
      <div
        aria-hidden="true"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          margin: "4px auto 10px",
          maxWidth: 180,
          opacity: 0.35,
        }}
      >
        <span
          style={{
            flex: 1,
            height: 1,
            background: "rgba(0,0,0,0.35)",
          }}
        />
        <span
          className="body-16"
          style={{
            fontSize: 11,
            letterSpacing: 1.4,
            textTransform: "uppercase",
          }}
        >
          {t("rsvp.choice.divider")}
        </span>
        <span
          style={{
            flex: 1,
            height: 1,
            background: "rgba(0,0,0,0.35)",
          }}
        />
      </div>

      <button
        type="button"
        onClick={onChooseRequest}
        className="body-16"
        style={{
          background: "none",
          border: "none",
          color: "var(--black)",
          opacity: 0.75,
          cursor: "pointer",
          padding: 0,
          fontSize: 14,
          textDecoration: "underline",
          textUnderlineOffset: 3,
        }}
      >
        {t("rsvp.choice.requestButton")}
      </button>
    </div>
  );
};

export default ChoiceScreen;
